export default __webpack_public_path__ + "static/media/business-model-zoo-tm.613f19c5.svg";